import React from 'react';
import ServerStatus from '../../../components/metrics/ServerStatus';
import mongoDbStore from '../../../../stores/mongodb.store';
import { useObserver } from 'mobx-react-lite';
import { useHistory } from 'react-router-dom';
import { ServerNameStyled } from './ServerItem2';
import { EuiIcon } from '@elastic/eui';
import alarmsStore from '../../../../stores/alarms.store';
import mongoDbMetricsStore from '../../../../stores/mongoMetrics.store';
import MongoOverviewCards from './mongo/MongoOverviewCards';
import MongoMetricsPanel from './mongo/MongoMetricsPanel';
import MongoDatabaseInspector from './mongo/MongoDatabaseInspector';

const MongoItemWrapper = props => {
    return useObserver(() => (
        <>
            <ServerStatus
                server={ mongoDbStore.mongoDbListObj[props.serverId] }
                url={ 'mongo' }
            />
            <MongoItem
                server={ mongoDbStore.mongoDbListObj[props.serverId] }
                alarms={ alarmsStore.alarmsByServerObj[props.serverId] }
                metrics={ mongoDbMetricsStore.mongoDbMetrics }
            />
        </>
    ));
};

export default MongoItemWrapper;

const MongoItem = props => {
    const history = useHistory();
    const { server, alarms, metrics } = props;

    if (!server) {
        return null;
    }

    // Set page title
    document.title = `${ server.name } - SyAgent`;

    const { metric } = server;
    if (!metric) return null;

    const { dataBases, dbsStats } = metric;

    return (
        <div className="mongo" style={{ paddingBottom: '30px' }}>
            <ServerNameStyled style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '20px', fontWeight: 'bold', margin: '15px 20px' }}>
                <EuiIcon type="logoMongodb" size="l" />
                { server.name }
            </ServerNameStyled>

            <MongoOverviewCards
                server={ server }
                metrics={ metrics }
            />

            <MongoMetricsPanel
                server={ server }
                alarms={ alarms }
                metrics={ metrics }
            />

            <MongoDatabaseInspector
                dataBases={ dataBases }
                dbsStats={ dbsStats }
            />
        </div>
    );
};
